import { Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

// taken from https://gist.github.com/ahmeti/5ca97ec41f6a48ef699ee6606560d1f7

@Directive({
    selector: '[lib-alphanumeric]',
    standalone: false
})
export class AlphanumericDirective {

    constructor(private el: ElementRef<HTMLInputElement>) {}

    validateAlphanumeric(event: KeyboardEvent): boolean {
        const key: string = event.key;
        if (key === 'Backspace' || key === 'Delete' || key === 'Tab')
            return;

        const regex: RegExp = /^[a-zA-Z0-9]$/;
        let isAlphanumeric: boolean = regex.test(key);

        if (event.key === 'Dead' || event.key === 'Unidentified')
            isAlphanumeric = false;

        if (!isAlphanumeric) {
            event.preventDefault();
        }

        return isAlphanumeric;
    }


    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        return this.validateAlphanumeric(event);
    }

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        return this.validateAlphanumeric(event);
    }

}
